/**
 * Row of four KPI cards for the dashboard overview.
 */

import { BarChart3, Users, MapPin, TrendingUp } from 'lucide-react';
import type { KpiData } from '@/lib/dashboard/aggregations';

function KpiCard({
  label,
  value,
  icon: Icon,
  accent,
}: {
  label: string;
  value: string | number;
  icon: React.ElementType;
  accent: string;
}) {
  return (
    <div className="flex items-center gap-4 rounded-xl border bg-card p-5 shadow-sm">
      <div
        className="flex h-12 w-12 items-center justify-center rounded-lg"
        style={{ backgroundColor: accent + '18', color: accent }}
      >
        <Icon className="h-6 w-6" />
      </div>
      <div>
        <p className="text-sm font-medium text-muted-foreground">{label}</p>
        <p className="text-2xl font-bold text-foreground">{value}</p>
      </div>
    </div>
  );
}

export function KpiCardRow({ data }: { data: KpiData }) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <KpiCard
        label="Total Observations"
        value={data.totalObservations}
        icon={BarChart3}
        accent="#3a86c8"
      />
      <KpiCard
        label="System Average"
        value={data.systemAverage !== null ? data.systemAverage.toFixed(2) : '—'}
        icon={TrendingUp}
        accent="#8fbf3f"
      />
      <KpiCard
        label="Children Served"
        value={data.childrenServed}
        icon={Users}
        accent="#c6a24a"
      />
      <KpiCard
        label="Sites Observed"
        value={data.sitesObserved}
        icon={MapPin}
        accent="#e36a4d"
      />
    </div>
  );
}
